<template>
  <div class="flex items-center px-1 text-xs">
    <svg class="w-[16px] fill-current mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 586.09 586.12">
      <path
        d="M103.44,299.4c0,101.19,82.06,183.25,183.3,183.25,7.65,0,13.88-6.23,13.88-13.88v-50.88c.67-29.45-42.37.34-86.29-44.81-47.27-48.47-17.49-87.62-44.86-87.62h-52.07c-7.73,0-13.96,6.23-13.96,13.93Z" />
      <path
        d="M582.03,412.91l-123.5-123.5c-2.28-2.26-5.29-3.74-8.8-4.02l-59.39-4.7c12.66-12.74,32.04-26.13,19.23-39l-65.15-65.17c-12.89-12.82-26.28,6.56-39.02,19.3l-4.64-59.47c-.26-3.42-1.82-6.51-4.07-8.8L173.18,4.07c-5.45-5.42-14.3-5.42-19.72,0L63.75,93.79c-5.42,5.42-5.42,14.27,0,19.69l123.5,123.52c2.54,2.54,5.92,3.89,9.18,4.07l59.08,4.64c-12.74,12.74-32.12,26.15-19.25,39l65.12,65.17c12.87,12.82,26.28-6.56,39.02-19.3l4.62,59.08c.21,3.35,1.53,6.64,4.1,9.18l123.5,123.5c5.42,5.42,14.27,5.42,19.72,0l89.69-89.72c5.42-5.42,5.42-14.27,0-19.72Z" />
      <path
        d="M286.69,506.31c-83.36,0-159.12-50.07-191.16-127.57-25.61-61.7-5.09-93.27-29.71-93.27H13.85c-7.63,0-13.85,6.23-13.85,13.96,0,158.42,128.25,286.69,286.69,286.69,7.71,0,13.93-6.17,13.93-13.88v-50.77c.21-8.98-5.81-15.15-13.93-15.15Z" />
    </svg>
    <span>RTK : </span>
    <span class="text-sm">
      {{ RTK }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    config: Object
  },
  computed: {
    RTK() {
      return this.config?.drone?.status?.position_state?.rtk_number != undefined
        ? this.config.drone.status.position_state.rtk_number
        : ENV.NO_DATA;
    },
  },
};
</script>
